import { Nav } from "react-bootstrap";
import { type ReactNode } from "react";

interface Props {
  eventKey: string;
  className?: string;
  children: ReactNode;
  visible?: boolean;
  to?: string;
  key?: string;
}

const TrellisNavLink = ({ eventKey, className, children, key, visible = true }: Props) => {
  if (!visible) {
    return null;
  }
  return (
    <Nav.Link eventKey={eventKey} className={className} key={key}>
      {children}
    </Nav.Link>
  );
};

export default TrellisNavLink;
